import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  autoResponseApi,
  type CreateAutoResponseRuleRequest,
  type UpdateAutoResponseRuleRequest,
} from '@/lib/api';

// V130 / Tier 2.6 — comment / mention auto-response rules.
export const useAutoResponseRules = (workspaceId: string) =>
  useQuery({
    queryKey: ['auto-responses', workspaceId],
    queryFn: () => autoResponseApi.list(workspaceId),
    enabled: !!workspaceId,
  });

export const useCreateAutoResponseRule = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateAutoResponseRuleRequest) => autoResponseApi.create(workspaceId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auto-responses', workspaceId] }),
  });
};

export const useUpdateAutoResponseRule = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateAutoResponseRuleRequest }) =>
      autoResponseApi.update(workspaceId, id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auto-responses', workspaceId] }),
  });
};

export const useDeleteAutoResponseRule = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => autoResponseApi.delete(workspaceId, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auto-responses', workspaceId] }),
  });
};
